import { render, staticRenderFns } from "./SoDataTable.vue?vue&type=template&id=7d42efce"
import script from "./SoDataTable.vue?vue&type=script&lang=js"
export * from "./SoDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports